var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "n-page",
    [
      _c(
        "a-row",
        [
          _c(
            "a-col",
            { attrs: { lg: 12, md: 24, sm: 24, xs: 24 } },
            [
              _c(
                "a-card",
                { attrs: { title: "Club Settings" } },
                [
                  _c(
                    "a-form",
                    { attrs: { form: _vm.form, layout: "vertical" } },
                    [
                      _vm.club.club_logo
                        ? [
                            _c("img", {
                              staticStyle: {
                                "max-height": "120px",
                                "max-width": "100%",
                              },
                              attrs: { src: _vm.clubLogo },
                              on: { error: _vm.defaultImage },
                            }),
                          ]
                        : _vm._e(),
                      _c("p", { staticClass: "gx-mt-3" }, [
                        _vm._v(
                          "\n            We suggest using a 400x400px png or jpeg image for your logo\n          "
                        ),
                      ]),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-upload",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["upload"],
                                  expression: "['upload']",
                                },
                              ],
                              attrs: {
                                accept: "image/png,image/jpeg,/image/jpg",
                                name: "logo",
                                data: _vm.enjectRole,
                                action: `${_vm.action}/club/upload-club-logo`,
                                headers: {
                                  Authorization: "Bearer " + _vm.userToken,
                                },
                                "list-type": "picture",
                              },
                              on: { change: _vm.uploadImage },
                            },
                            [
                              _c(
                                "a-button",
                                [
                                  _c("a-icon", { attrs: { type: "upload" } }),
                                  _vm._v(" Change your Logo "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Club Name" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "club_name",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message:
                                          "Please enter the name of your club.",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                'club_name',\n                {\n                  rules: [\n                    {\n                      required: true,\n                      message: 'Please enter the name of your club.',\n                    },\n                  ],\n                },\n              ]",
                              },
                            ],
                            attrs: { type: "text" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Club Email" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "email",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "Club email is required.",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                'email',\n                {\n                  rules: [\n                    {\n                      required: true,\n                      message: 'Club email is required.',\n                    },\n                  ],\n                },\n              ]",
                              },
                            ],
                            attrs: { type: "text" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Contact Number" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "contact_phone",
                                  {
                                    rules: [
                                      {
                                        pattern: /^[0-9]{6,10}$/,
                                        message:
                                          "Phone number must be between 6 and 10 digits and in numeric form.",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                'contact_phone',\n                {\n                  rules: [\n                    {\n                      pattern: /^[0-9]{6,10}$/,\n                      message:\n                        'Phone number must be between 6 and 10 digits and in numeric form.',\n                    },\n                  ],\n                },\n              ]",
                              },
                            ],
                            attrs: {
                              type: "text",
                              inputmode: "numeric",
                              placeholder: "Enter contact number",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Main Address" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["address"],
                                expression: "['address']",
                              },
                            ],
                            attrs: { type: "textarea" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Facebook URL" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["facebook", _vm.facebookValidation],
                                expression: "['facebook', facebookValidation]",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "https://facebook.com",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Twitter URL" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["twitter", _vm.twitterValidation],
                                expression: "['twitter', twitterValidation]",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "https://x.com",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Website URL" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["website", _vm.urlValidation],
                                expression: "['website', urlValidation]",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "https://mywebsite.com",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { staticClass: "gx-text-right" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                "html-type": "submit",
                                loading: _vm.spinning,
                              },
                              on: { click: _vm.handleForm },
                            },
                            [
                              _vm._v(
                                "\n              Save Details\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }